import LockMessage from './LockMessage';

export default LockMessage;
